export default __webpack_public_path__ + "img/pin_icons/hammer_b.svg";